import { SelectableBoxField } from '@flos/react-ui';
import { HouseAddress as HouseAddressType } from '@topdanmark-onlinesolutions/claim-form-types';
import useAppState from '../../../state/appState';
import HouseAddress, { AddressOption } from './HouseAddress';
import { IEngagements } from '../../../types/services';
import { getDefaultAddresses } from './getDefaultAddresses';
import React from 'react';
import { getAddressesFromPolicies } from './getAddressesFromPolicies';
import { entriesFromObject } from '../../../helpers/entriesFromObject';
import { getTempElementId } from './getTempElementId';

export const AddressBox = ({
    elementId,
    addresses,
    engagements,
    setFormValue,
    formSubmitApiPath
}: {
    elementId: string;
    addresses: HouseAddressType['addresses'];
    engagements: IEngagements | null;
    setFormValue: (key: string, value: AddressOption) => void;
    formSubmitApiPath?: string;
}) => {
    const formValues = useAppState((state) => state.formValues);
    const value = HouseAddress.getValueOrDefault(formValues, elementId);
    const [selectableBoxOptions, setSelectableBoxOptions] = React.useState<AddressOption[]>([]);

    React.useEffect(() => {
        const defaultAddresses = getDefaultAddresses();
        const policyAddresses = getAddressesFromPolicies(engagements, formSubmitApiPath || '');
        const _selectableBoxOptions = entriesFromObject(addresses)
            .filter(([, value]) => !!value)
            .flatMap(([key]) => {
                switch (key) {
                    case 'showPolicyAddresses':
                        return policyAddresses.map((address) => {
                            return { ...address };
                        });
                    default:
                        return { ...defaultAddresses[key] };
                }
            });
        setSelectableBoxOptions(_selectableBoxOptions);
    }, [addresses, engagements, formSubmitApiPath]);

    return (
        <SelectableBoxField
            id={elementId}
            maxWidth="wide"
            onChangeValue={(selectedValue: string) => {
                const option = selectableBoxOptions.find((option) => option.value === selectedValue);
                if (!option) {
                    // if selectedValue does not exist reset formValue: Rare case tho.
                    setFormValue(elementId, {
                        ...getDefaultAddresses('showOtherPlace')
                    });
                    return;
                }
                switch (option.value) {
                    case 'showOtherAddressDanish':
                    case 'showOtherAddressForeign':
                    case 'showOtherPlace':
                        const valueObj: AddressOption | undefined =
                            formValues[getTempElementId(elementId, option.value)];
                        const valueLabel = valueObj?.valueOnSubmit.description ?? '';

                        setFormValue(elementId, {
                            ...option,
                            valueOnSubmit: {
                                ...option.valueOnSubmit,
                                description: valueLabel
                            }
                        });

                        break;
                    default:
                        setFormValue(elementId, {
                            ...option
                        });
                }
            }}
            options={selectableBoxOptions}
            required
            value={value.value}
        />
    );
};
